"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartingWizard = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const ChartingState_1 = require("../../../PredefinedConfig/ChartingState");
const AgChargingWizard_1 = require("./AgChargingWizard");
const ExternalChartingWizard_1 = require("./ExternalChartingWizard");
const ChartingWizard = (props) => {
    const { data, configEntities } = props, other = tslib_1.__rest(props, ["data", "configEntities"]);
    if ((0, ChartingState_1.isAgChartDefinition)(data)) {
        const chartDef = data;
        return (React.createElement(AgChargingWizard_1.AgChargingWizard, Object.assign({}, other, { data: chartDef })));
    }
    else {
        const chartDef = data;
        return (React.createElement(ExternalChartingWizard_1.ExternalChartingWizard, Object.assign({}, other, { data: chartDef })));
    }
};
exports.ChartingWizard = ChartingWizard;
